import { OwnerDashboard } from './OwnerDashboard';
import { AdminDashboard } from './AdminDashboard';
import { SupervisorDashboard } from './SupervisorDashboard';

export const DashboardPage = () => {
  const userData = localStorage.getItem('user_data');
  const user = userData ? JSON.parse(userData) : null;
  const role: string = user?.role ?? 'SUPERVISOR';

  if (role === 'OWNER') return <OwnerDashboard />;
  if (role === 'ADMIN') return <AdminDashboard />;
  return <SupervisorDashboard />;
};
